<app-home></app-home>
<div class="animated fadeIn fast jumbotron">
  <h1>Marco Antonio Islas Duran</h1>
  <h3>Desarrollo web</h3>
  <hr>
  <div class="container-fluid animated fadeIn">
  <span class='descripcion'>Soy un hombre de 45 años. Siempre quise dedicarme a esta maravillosa profesión de la programación pero por diversos motivos no lograba concretarlo. Ahora decidi hacer de esto mi mondus vivendi. 
  </span>
  <article>
  <ul class='lista'>
    <h3>Soy especialista en Front End:</h3>
    <span>He estudiado: </span>
    
    <li> HTML5 <i class="ico fab fa-html5"></i></li>
     <li>CSS3 <i class="ico fab fa-css3"></i></li>
     <li>JavaScript <i class="ico fab fa-js-square"></i></li>
     <li>Angular 8 <i class="ico fab fa-angular"></i></li> 
     <li> TypeScript</li>
     <li> Node JS <i class="ico2 fab fa-node-js"></i></li>
    <li> Jquery</li> 
    <li> BootStrap <i class="ico2 fab fa-bootstrap"></i></li> 
    <li> Mongo DB</li>
    <h3 class="py-3">Extras:</h3>
    <li> Control de versiones con Git <i class="ico2 fab fa-git-square"></i>y GitHub <i class="ico2 fab fa-github"></i>. </li>
    <h3 class="py-3">Algunos pastiempos que tengo son:</h3>
                    <li>Leer <i class=" ico2 fas fa-book-reader"></i></li>
                    <li>Jugar Ajedrez <i class=" ico2 fas fa-chess"></i></li>
                    <li>Sacar a caminar a mi perro <i class="ico2 fas fa-paw"></i></li>
  </ul>
  <div class="myself">
    <img src="../../../assets/img/yopi.jpg" alt="Marco Antonio Islas Duran">
  </div>
  </article>
  </div>
</div>
